/* eslint-disable */
/* tslint:disable */
/**
 * TCS does not have swagger docs. As a result, this api is NOT autogenerated by swagger-typescript-api.
 * https://atlassian.slack.com/archives/C03S3BHQQBD/p1675980355940209?thread_ts=1675959995.743339&cid=C03S3BHQQBD
 */

export interface LinkedOrg {
	orgId: string;
}

export type ProductInformation = {
	state: 'ACTIVE' | 'DEACTIVATED';
	edition?: 'free' | 'beta' | 'standard' | 'premium' | 'starter' | 'business' | 'business-ai';
	billingSourceSystem?: 'CCP' | 'HAMS';
	ccpTransactionAccountId?: string | null;
	ccpEntitlementId?: string | null;
	relatesFromEntitlements?: RelatesFromEntitlement[] | null;
	trialEndDate?: string | null;
	isSuspended?: boolean;
	relatesToEntitlements?: RelatesToEntitlements[] | null;
};

export type RelatesFromEntitlement = {
	entitlementId?: string | null;
	relationshipId?: string | null;
	relationshipType?:
		| 'FAMILY_CONTAINER'
		| 'COLLECTION'
		| 'APP_DEPENDENCE'
		| 'ADDON_DEPENDENCE'
		| 'SANDBOX_DEPENDENCE'
		| 'SANDBOX_GRANT'
		| 'ENTERPRISE'
		| null;
};

export type RelatesToEntitlements = RelatesFromEntitlement;

export const ProductKey = {
	CONFLUENCE: 'confluence.ondemand',
	JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
	JIRA_SOFTWARE: 'jira-software.ondemand',
	JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
	JIRA_WORK_MANAGEMENT: 'jira-core.ondemand',
	OPSGENIE: 'opsgenie',
	STATUSPAGE: 'statuspage',
	TEAM_CENTRAL: 'townsquare',
	COMPASS: 'compass',
	ANALYTICS: 'atlassian-analytics-free',
	BEACON: 'beacon',
	LOOM: 'loom',
	ROVO: 'rovo.ondemand',
} as const;
export type ProductKey = (typeof ProductKey)[keyof typeof ProductKey];
export type LicenseInformation = {
	products: Record<ProductKey, ProductInformation>;
};

export const DataResidencyProductKey = {
	JIRA_SOFTWARE: 'jira',
} as const;
export type DataResidencyProductKey =
	(typeof DataResidencyProductKey)[keyof typeof DataResidencyProductKey];

export type DataResidency = {
	realms: Record<
		DataResidencyProductKey,
		{
			pinnedRealm?: string;
		}
	>;
	dataResidency: Record<
		ProductKey,
		{
			isDataResidencyAllowed: boolean;
		}
	>;
};

export const AccessCheckAri = {
	confluence: 'ari:cloud:confluence::site/',
	jira: 'ari:cloud:jira::site/',
	townsquare: 'ari:cloud:townsquare::site/',
	loom: 'ari:cloud:loom::site/',
	rovo: 'ari:cloud:rovo::site/',
	watermelon: 'ari:cloud:townsquare::site/',
	atlas: 'ari:cloud:townsquare::site/',
} as const;

export type OriginProduct = keyof typeof AccessCheckAri;

type OrgLinks = {
	target: {
		ari: string;
		metadata: Record<string, string>;
	};
	metadata: Record<string, string>;
};

export type OrganizationLinks = {
	links: OrgLinks[];
	orgId: string;
};

export type CustomEmailFooter = {
	isEnabled: boolean;
	footerText?: string;
};
